import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=f98eb612&scoped=true"
import script from "./SelectComponent.vue?vue&type=script&lang=js"
export * from "./SelectComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectComponent.vue?vue&type=style&index=0&id=f98eb612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98eb612",
  null
  
)

export default component.exports